// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────────────────────
   contentSectionEditPageJobDetail.css
   Scoped prefix: scl--cms-content-edit-jobdetail-
   ───────────────────────────────────────────────────────────────────────────── */

/* ─── Root ──────────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-root {
  width: 100%;
  max-width: 1920px;
  padding: 10px 130px 20px 130px;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

/* ─── Skeleton ──────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-skeleton-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
}

@keyframes scl--cms-content-edit-jobdetail-shimmer {
  0%   { background-position: 100% 50%; }
  100% { background-position:   0% 50%; }
}

.scl--cms-content-edit-jobdetail-skeleton {
  border-radius: 4px;
  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);
  background-size: 400% 100%;
  animation: scl--cms-content-edit-jobdetail-shimmer 1.4s ease infinite;
}
.scl--cms-content-edit-jobdetail-skeleton--title { height: 40px; width: 280px; }
.scl--cms-content-edit-jobdetail-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }
.scl--cms-content-edit-jobdetail-skeleton--field { height: 44px; width: 100%; }

/* ─── Empty state ───────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 8px;
  text-align: center;
}
.scl--cms-content-edit-jobdetail-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }
.scl--cms-content-edit-jobdetail-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }

/* ─── Page heading ──────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-page-title {
  margin: 0 0 6px;
  font-size: 36px;
  font-weight: 600;
  line-height: 40px;
  color: #323539;
}
.scl--cms-content-edit-jobdetail-page-desc {
  margin: 0 0 28px;
  font-size: 16px;
  line-height: 24px;
  color: #8A8B8F;
  letter-spacing: -0.01em;
}

/* ─── Meta grid ─────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;
  margin-bottom: 32px;
}
.scl--cms-content-edit-jobdetail-meta-grid > *:nth-child(5) { grid-column: 1; }

/* ─── Section heading row — heading left, toggle right ──────────────────────── */
.scl--cms-content-edit-jobdetail-section-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.scl--cms-content-edit-jobdetail-section-heading {
  font-size: 16px;
  font-weight: 600;
  color: #323539;
  margin: 0;
}

/* ─── Divider ───────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-divider {
  height: 1px;
  background: #E1E4ED;
  margin-bottom: 20px;
}

/* ─── Label row ─────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 8px;
}
.scl--cms-content-edit-jobdetail-label    { font-size: 14px; color: #323539; font-weight: 400; }
.scl--cms-content-edit-jobdetail-required { color: #FF4D4F; }

/* ─── Card selector row ─────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
  position: relative;
  z-index: 10;
  margin-top: 20px;
  margin-bottom: 0;
  padding-bottom: 12px;
  gap: 12px;
}

.scl--cms-content-edit-jobdetail-card-row > .scl--cms-content-edit-jobdetail-label {
  flex: 1;
  min-width: 0;
}

.scl--cms-content-edit-jobdetail-card-row-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  overflow: visible;
  position: relative;
  z-index: 10;
}

.scl--cms-content-edit-jobdetail-card-select,
.scl--cms-content-edit-jobdetail-card-select .scl--cms-components-selectFieldInline-container {
  width: 220px;
  min-width: 0;
  flex-shrink: 0;
}

.scl--cms-content-edit-jobdetail-card-row-right > *:last-child {
  flex-shrink: 0;
  flex-grow: 0;
}

.scl--cms-content-edit-jobdetail-card-select .scl--cms-components-selectFieldInline-dropdown,
.scl--cms-content-edit-jobdetail-card-select [class*="dropdown"],
.scl--cms-content-edit-jobdetail-card-select [class*="menu"] {
  z-index: 9999;
  position: absolute;
}

/* ─── SplitRow ──────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-split-row {
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 60px;
  background: #FDFDFD;
  border: 1px dashed rgba(208, 213, 221, 0.3);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}

.scl--cms-content-edit-jobdetail-split-row--multiline {
  min-height: 110px;
  align-items: flex-start;
}

/* Green left accent bar */
.scl--cms-content-edit-jobdetail-split-accent {
  width: 4px;
  flex-shrink: 0;
  background: #84A578;
  border-radius: 0 0 2px 2px;
  align-self: stretch;
}

/* Row body */
.scl--cms-content-edit-jobdetail-split-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px 10px 16px;
  gap: 12px;
  min-height: 60px;
}

.scl--cms-content-edit-jobdetail-split-row--multiline
.scl--cms-content-edit-jobdetail-split-body {
  align-items: flex-start;
  padding-top: 14px;
  padding-bottom: 14px;
  min-height: 110px;
}

/* Current value — left */
.scl--cms-content-edit-jobdetail-split-current {
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
  word-break: break-word;
}

/* Input slot — right */
.scl--cms-content-edit-jobdetail-split-slot {
  flex-shrink: 0;
  width: 240px;
}

/* Textarea slot */
.scl--cms-content-edit-jobdetail-split-slot--textarea {
  width: 351px;
}
.scl--cms-content-edit-jobdetail-split-slot--textarea textarea {
  max-height: 110px;
  overflow-y: auto;
  resize: none;
  box-sizing: border-box;
}

/* ─── Footer actions ────────────────────────────────────────────────────────── */
.scl--cms-content-edit-jobdetail-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/content/edit-content/job-detail-page/css/contentSectionEditPageJobDetail.css"],"names":[],"mappings":"AAAA;;;kFAGkF;;AAElF,kFAAkF;AAClF;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,qEAAqE;AACvE;AACA,mDAAmD,YAAY,EAAE,YAAY,EAAE;AAC/E,mDAAmD,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACnG,mDAAmD,YAAY,EAAE,WAAW,EAAE;;AAE9E,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;AACpB;AACA,+CAA+C,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAC7G,+CAA+C,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAElG,kFAAkF;AAClF;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;AACA,8DAA8D,cAAc,EAAE;;AAE9E,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA,4CAA4C,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC/F,4CAA4C,cAAc,EAAE;;AAE5D,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB","sourcesContent":["/* ─────────────────────────────────────────────────────────────────────────────\n   contentSectionEditPageJobDetail.css\n   Scoped prefix: scl--cms-content-edit-jobdetail-\n   ───────────────────────────────────────────────────────────────────────────── */\n\n/* ─── Root ──────────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-root {\n  width: 100%;\n  max-width: 1920px;\n  padding: 10px 130px 20px 130px;\n  box-sizing: border-box;\n  font-family: 'Inter', sans-serif;\n}\n\n/* ─── Skeleton ──────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-skeleton-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 24px;\n}\n\n@keyframes scl--cms-content-edit-jobdetail-shimmer {\n  0%   { background-position: 100% 50%; }\n  100% { background-position:   0% 50%; }\n}\n\n.scl--cms-content-edit-jobdetail-skeleton {\n  border-radius: 4px;\n  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);\n  background-size: 400% 100%;\n  animation: scl--cms-content-edit-jobdetail-shimmer 1.4s ease infinite;\n}\n.scl--cms-content-edit-jobdetail-skeleton--title { height: 40px; width: 280px; }\n.scl--cms-content-edit-jobdetail-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }\n.scl--cms-content-edit-jobdetail-skeleton--field { height: 44px; width: 100%; }\n\n/* ─── Empty state ───────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 8px;\n  text-align: center;\n}\n.scl--cms-content-edit-jobdetail-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }\n.scl--cms-content-edit-jobdetail-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }\n\n/* ─── Page heading ──────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-page-title {\n  margin: 0 0 6px;\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 40px;\n  color: #323539;\n}\n.scl--cms-content-edit-jobdetail-page-desc {\n  margin: 0 0 28px;\n  font-size: 16px;\n  line-height: 24px;\n  color: #8A8B8F;\n  letter-spacing: -0.01em;\n}\n\n/* ─── Meta grid ─────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-meta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 24px;\n  margin-bottom: 32px;\n}\n.scl--cms-content-edit-jobdetail-meta-grid > *:nth-child(5) { grid-column: 1; }\n\n/* ─── Section heading row — heading left, toggle right ──────────────────────── */\n.scl--cms-content-edit-jobdetail-section-heading-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.scl--cms-content-edit-jobdetail-section-heading {\n  font-size: 16px;\n  font-weight: 600;\n  color: #323539;\n  margin: 0;\n}\n\n/* ─── Divider ───────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-divider {\n  height: 1px;\n  background: #E1E4ED;\n  margin-bottom: 20px;\n}\n\n/* ─── Label row ─────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n  margin-bottom: 8px;\n}\n.scl--cms-content-edit-jobdetail-label    { font-size: 14px; color: #323539; font-weight: 400; }\n.scl--cms-content-edit-jobdetail-required { color: #FF4D4F; }\n\n/* ─── Card selector row ─────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-card-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible;\n  position: relative;\n  z-index: 10;\n  margin-top: 20px;\n  margin-bottom: 0;\n  padding-bottom: 12px;\n  gap: 12px;\n}\n\n.scl--cms-content-edit-jobdetail-card-row > .scl--cms-content-edit-jobdetail-label {\n  flex: 1;\n  min-width: 0;\n}\n\n.scl--cms-content-edit-jobdetail-card-row-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  overflow: visible;\n  position: relative;\n  z-index: 10;\n}\n\n.scl--cms-content-edit-jobdetail-card-select,\n.scl--cms-content-edit-jobdetail-card-select .scl--cms-components-selectFieldInline-container {\n  width: 220px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.scl--cms-content-edit-jobdetail-card-row-right > *:last-child {\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.scl--cms-content-edit-jobdetail-card-select .scl--cms-components-selectFieldInline-dropdown,\n.scl--cms-content-edit-jobdetail-card-select [class*=\"dropdown\"],\n.scl--cms-content-edit-jobdetail-card-select [class*=\"menu\"] {\n  z-index: 9999;\n  position: absolute;\n}\n\n/* ─── SplitRow ──────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-split-row {\n  box-sizing: border-box;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 60px;\n  background: #FDFDFD;\n  border: 1px dashed rgba(208, 213, 221, 0.3);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n\n.scl--cms-content-edit-jobdetail-split-row--multiline {\n  min-height: 110px;\n  align-items: flex-start;\n}\n\n/* Green left accent bar */\n.scl--cms-content-edit-jobdetail-split-accent {\n  width: 4px;\n  flex-shrink: 0;\n  background: #84A578;\n  border-radius: 0 0 2px 2px;\n  align-self: stretch;\n}\n\n/* Row body */\n.scl--cms-content-edit-jobdetail-split-body {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px 10px 16px;\n  gap: 12px;\n  min-height: 60px;\n}\n\n.scl--cms-content-edit-jobdetail-split-row--multiline\n.scl--cms-content-edit-jobdetail-split-body {\n  align-items: flex-start;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  min-height: 110px;\n}\n\n/* Current value — left */\n.scl--cms-content-edit-jobdetail-split-current {\n  flex: 1;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 0, 0, 0.8);\n  word-break: break-word;\n}\n\n/* Input slot — right */\n.scl--cms-content-edit-jobdetail-split-slot {\n  flex-shrink: 0;\n  width: 240px;\n}\n\n/* Textarea slot */\n.scl--cms-content-edit-jobdetail-split-slot--textarea {\n  width: 351px;\n}\n.scl--cms-content-edit-jobdetail-split-slot--textarea textarea {\n  max-height: 110px;\n  overflow-y: auto;\n  resize: none;\n  box-sizing: border-box;\n}\n\n/* ─── Footer actions ────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-jobdetail-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
